module.exports = __webpack_public_path__ + "static/shipkoo-shipping-south-korea-51f332afbff4db0ee7bdb8f139d7a60e.png";